export default __webpack_public_path__ + "static/BanImg4-356e5cc4366eaa151f908dbc62ad2cc3.webp";